<template>
<div class='create-date-layout'>
    <header class='create-date-title'>
        <span class='pull-left'>创建日程</span>
    </header>
    <div class='transportation'>
        <!-- <Row>
            <Col span='3'>行车方式</Col>
            <RadioGroup v-model="vehicleType" style="float:left">
              <Radio label='3'>汽车</Radio>
              <Radio label='2' class='dt-mar40l'>电动车</Radio>
              <Radio label='1' class='dt-mar40l'>步行</Radio>
            </RadioGroup>
        </Row>
        <Row class='ivu-bg' style='margin-bottom:6px;'>
            <Col span='3'>速度</Col>
            <span class='pull-left text'>正常速度</span>
            <Input v-model="speed" placeholder="0.1~5倍" class='pull-left' style='margin-top:4px;'></Input>
        </Row> -->
        <Row>
            <Col span='3'>排班周期</Col>
            <div class='pull-left'>
              <DatePicker v-model="workDate" style="width: 300px;" :value="workDate" format="yyyy年MM月dd日" type="daterange" placement="bottom-end" placeholder="选择排班周期"></DatePicker>
            </div>
        </Row>
        <Row class='ivu-bg'>
            <Col span='3'>工作时间</Col>
            <div class='pull-left'>
              <TimePicker v-model="workTime" :value='workTime' format="HH:mm" type="timerange" placement="bottom-end" placeholder="选择起始和结束的工作时间" style="width: 116px"></TimePicker>
            </div>
        </Row>
        <div class='dt-hidden ivu-bg date-picker-panel'>
            <Col span='3'>工作日历</Col>
            <div class="pull-left">
                <div id="createCalendar"></div>
            </div>
        </div>
        <!-- <Row class='ivu-bg'>
            <Col span='3'>每天最多拜访客户数</Col>
            <div class='pull-left every-day'>
                <InputNumber :max="50" :min="1" v-model="maxVisits" style='width:200px;'></InputNumber>
                <span class="unit">个</span>
            </div>
        </Row>
        <Row class='ivu-bg'>
            <Col span='3'>每天最少拜访客户数</Col>
            <div class='pull-left every-day'>
                <InputNumber :max="50" :min="1" v-model="minVisits" style='width:200px;'></InputNumber>
                <span class="unit">个</span>
            </div>
        </Row> -->
        <Row>
            <Col span='3'>每天最多行驶里程</Col>
            <div class='pull-left every-day'>
                <InputNumber :max="100" :min="1" style='width:200px;' v-model="maxDistance"></InputNumber>
                <span class="unit">千米</span>
            </div>
        </Row>
        <Row class='button-group ivu-bg'>
            <div>
                <Button type="primary" class='pull-right dt-mar10l' @click='createDailyInfo()'>创建日程</Button>
                <Button @click='closeCreateDatePanel()' class='pull-right'>取消</Button>
            </div>
        </Row>
    </div>
</div>

</template>
<script>

import moment from 'moment';
export default {
  data () {
    return {
      vehicleType: '3',
      maxVisits: 18,
      minVisits: 10,
      maxDistance: 0,
      speed: 1,
      workTime: ["09:00", "18:00"],
      workDate: [],
      holiday: [],
      type: null
    };
  },
  props: ['createDateInfo', 'userId'],
  watch: {
    createDateInfo: function (){
      this.vehicleType = this.createDateInfo.vehicle_type.toString();
      this.speed = this.createDateInfo.speed_adjustment / 100;
      this.holiday = this.createDateInfo.holiday;
      this.maxDistance = parseInt(this.createDateInfo.max_distance) || 0;
      this.maxVisits = parseInt(this.createDateInfo.max_visits) || 0;
      this.minVisits = parseInt(this.createDateInfo.min_visits) || 0;
      this.createDailyInfoDate();
    },
    'createDateInfo.max_distance': function (){
      this.maxDistance = parseInt(this.createDateInfo.max_distance) || 0;
    },
    'createDateInfo.max_visits': function (){
      this.maxVisits = parseInt(this.createDateInfo.max_visits) || 0;
    },
    'createDateInfo.min_visits': function (){
      this.minVisits = parseInt(this.createDateInfo.min_visits) || 0;
    },
    'createDateInfo.holiday': function (){
      this.holiday = this.createDateInfo.holiday;
      this.createDailyInfoDate();
    },
    'createDateInfo.speed_adjustment': function (){
      this.speed = this.createDateInfo.speed_adjustment / 100;
    },
    'createDateInfo.vehicle_type': function (){
      this.vehicleType = this.createDateInfo.vehicle_type.toString();
    }
  },
  events: ['closeCreateDate', 'createDateSuccess'],
  mounted () {
    this.workDate.push(this.getCurrentMonthFirstDay());
    this.workDate.push(this.getCurrentMonthLastDay());
  },
  methods: {
    createDailyInfo: async function (){
      if (this.workDate.length === 0){
        this.$Message.error('工作日期不能为空');
        return false;
      }
      if (this.workTime.length === 0){
        this.$Message.error('工作时间不能为空');
        return false;
      }
      // if (isNaN(this.speed)) {
      //   this.$Message.error('速度只能是数值类型');
      //   return false;
      // }
      // if (this.speed < 0.1 || this.speed > 5){
      //   this.$Message.error('速度范围只能是正常速度的0.1~5倍之间');
      //   return false;
      // }
      let params = {
        user_id: this.userId,
        startDate: moment(this.workDate[0]).format('YYYY-MM-DD'), // new Date(this.workDate[0]).toLocaleDateString(),
        endDate: moment(this.workDate[1]).format('YYYY-MM-DD'), // new Date(this.workDate[1]).toLocaleDateString(),
        workStartTime: this.workTime[0].toTimeString().split(" ")[0],
        workEndTime: this.workTime[1].toTimeString().split(" ")[0],
        maximumVisits: this.maxVisits,
        minVisits: this.minVisits,
        maxDistance: this.maxDistance,
        speed: this.speed,
        vehicleType: parseInt(this.vehicleType)
      };
      this.$emit('readyCreateDate', params);
    },
    createDailyInfoDate: function (){
      let self = this;
      $('#createCalendar').empty();
      $('#createCalendar').calendar({
        ifSwitch: true, // 是否切换月份
        hoverDate: false, // hover是否显示当天信息
        backToday: false, // 是否返回当天
        dates: this.holiday,
        afterInit: function (today){
          self.today = today;
        },
        onClick: function (today, selectDay){
          self.today = selectDay;
        }
      });
    },
    closeCreateDatePanel: function (){
      this.$emit('closeCreateDate');
    },
    getCurrentMonthFirstDay: function (){
      let date = new Date();
      date.setDate(1);
      return date.toLocaleDateString();
    },
    getCurrentMonthLastDay: function (){
      let date = new Date();
      let currentMonth = date.getMonth();
      let nextMonth = ++currentMonth;
      let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      let oneDay = 1000 * 60 * 60 * 24;
      return new Date(nextMonthFirstDay - oneDay);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CreateDate.vue